import AlbumComp from "@components/Collection/album";
import LBox from "@components/LBox";
import PlaylistComp from "@components/Collection/playlist";
import PersonalPlaylistComp from "@components/Collection/playlist/PersonalPlaylist";
import TodaysTopHitsComp from "@components/Collection/playlist/TodaysTopHitsPlaylist";
import { useLocalSearchParams } from "expo-router";
import React, { useEffect, useMemo } from "react";
import GoBack from "@components/GoBack";
import LScreen from "@components/LScreen";
import { useWindowDimensions } from "react-native";
import config from "@utils/config";
import { BackgroundColor } from "@theme";
import LSuspense from "@components/LSuspense";
import * as rudderstack from "@utils/rudderstack";
import { TODAYS_TOP_HITS_ID } from "@libs/utils";
import type { CatalogCollectionType } from "@utils/player";

type CollectionParams = {
  collectionId: string;
  collectionType: Exclude<CatalogCollectionType, "artist">;
  songId: string;
};

export const CollectionScreen = () => {
  const { collectionId, collectionType, songId } =
    useLocalSearchParams<CollectionParams>();
  const dimensions = useWindowDimensions();
  const gradientHeight = dimensions.height / 2 - config.UI.topBarHeight;

  const gradientColours: BackgroundColor[] = useMemo(() => {
    const topColor = `${collectionType}TopBg` as const;
    const bottomColor = `${collectionType}BottomBg` as const;

    if (collectionType === "album") {
      return [topColor, bottomColor];
    }

    return [topColor, topColor, bottomColor];
  }, [collectionType]);

  useEffect(() => {
    void rudderstack.track("view_collection", {
      collectionId,
      collectionType,
    });
  }, [collectionId, collectionType]);

  if (!collectionId || !collectionType) {
    return <GoBack />;
  }

  return (
    <LScreen enableAutomaticTopPadding={true} paddingHorizontal="zero">
      <LBox
        backgroundColor={gradientColours}
        bottom={0}
        height={gradientHeight}
        left={0}
        position="absolute"
        right={0}
        top={0}
      />
      <LSuspense contentContainerStyle={{ backgroundColor: "transparent" }}>
        {collectionType === "playlist" ? (
          collectionId.startsWith("liked_") ||
          collectionId === "discover_daily" ? (
            <PersonalPlaylistComp id={collectionId} songId={songId} />
          ) : collectionId.endsWith(TODAYS_TOP_HITS_ID) ? (
            <TodaysTopHitsComp id={collectionId} songId={songId} />
          ) : (
            <PlaylistComp id={collectionId} songId={songId} />
          )
        ) : collectionType === "album" ? (
          <AlbumComp id={collectionId} songId={songId} />
        ) : null}
      </LSuspense>
    </LScreen>
  );
};
